import axios from "axios";

export const GET_ESTADO_CUMPLIMIENTO_ESTABLECIMIENTOS =
  "GET_ESTADO_CUMPLIMIENTO_ESTABLECIMIENTOS";
export const GET_FORMULARIOS_PREVENCION_ESTABLECIMIENTO =
  "GET_FORMULARIOS_PREVENCION_ESTABLECIMIENTO";
export const DESCARGAR_FORMULARIO_RAR_PDF = "DESCARGAR_FORMULARIO_RAR_PDF";
export const DESCARGAR_FORMULARIO_RGRL_PDF = "DESCARGAR_FORMULARIO_RGRL_PDF";
export const GET_FORMULARIO_RAR_PDF = "GET_FORMULARIO_RAR_PDF";
export const GET_FORMULARIO_RGRL_PDF = "GET_FORMULARIO_RGRL_PDF";
export const POST_FORMULARIO_RAR_FIRMADO = "POST_FORMULARIO_RAR_FIRMADO";
export const POST_FORMULARIO_RGRL_FIRMADO = "POST_FORMULARIO_RGRL_FIRMADO";
export const CLEAR_VISUALIZACION = "CLEAR_VISUALIZACION";
export const DESCARGAR_FORMULARIO_CANCERIGENOS =
  "DESCARGAR_FORMULARIO_CANCERIGENOS";
export const GET_FORMULARIO_CANCERIGENOS = "GET_FORMULARIO_CANCERIGENOS";
export const DESCARGAR_FORMULARIO_PRESENTADO =
  "DESCARGAR_FORMULARIO_PRESENTADO";
export const VISUALIZAR_FORMULARIO_PRESENTADO =
  "VISUALIZAR_FORMULARIO_PRESENTADO";
export const VISUALIZAR_CERTIFICADO_PRESENTACION =
  "VISUALIZAR_CERTIFICADO_PRESENTACION";
export const GET_ESTABLECIMIENTOS_TIPO_O = "GET_ESTABLECIMIENTOS_TIPO_O";

export const getEstadoCumplimientoEstablecimientos = () => (dispatch) => {
  return dispatch({
    type: GET_ESTADO_CUMPLIMIENTO_ESTABLECIMIENTOS,
    payload: axios
      .get(`empleador/datosCompletosDependenciasEmpleador`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getFormulariosPrevencionEstablecimiento = (id) => (dispatch) => {
  return dispatch({
    type: GET_FORMULARIOS_PREVENCION_ESTABLECIMIENTO,
    payload: axios
      .get(
        `dependenciaEmpleador/formulariosPrevencionConEstados?idDependenciaEmpleador=${id}`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const descargarFormularioPresentado = (id) => (dispatch) => {
  return dispatch({
    type: DESCARGAR_FORMULARIO_PRESENTADO,
    payload: axios
      .get(
        `formularioPrevencion/descargarPresentado?idFormularioProgramaPrevencionEmpleador=${id}`,
        {
          responseType: "blob",
        }
      )
      .then((response) => {
        let fileName =
          response?.headers["content-disposition"]?.split("filename=")[1];
        return { data: response.data, fileName };
      })
      .catch((error) => Promise.reject(error)),
  });
};

export const visualizarFormularioPresentado = (id) => (dispatch) => {
  return dispatch({
    type: VISUALIZAR_FORMULARIO_PRESENTADO,
    payload: axios
      .get(
        `formularioPrevencion/visualizarPresentado?idFormularioProgramaPrevencionEmpleador=${id}`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const visualizarCertificadoPresentacion = (id) => (dispatch) => {
  return dispatch({
    type: VISUALIZAR_CERTIFICADO_PRESENTACION,
    payload: axios
      .get(
        `formularioPrevencion/visualizarCertificadoPresentacion?idFormularioProgramaPrevencionEmpleador=${id}`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const postFormularioRarFirmado = (file, formulario) => (dispatch) => {
  const data = {
    // este idFormularioCorrespondiente viene a ser el idRAR que el back
    // resuelve por nosotros, idRAR **NO** es lo mismo que idFormularioProgramaPreven...
    idRAR: formulario?.idFormularioCorrespondiente,
    observaciones: "",
    archivosAsociados: [{ base64: file?.value, extension: "pdf" }],
  };

  return dispatch({
    type: POST_FORMULARIO_RAR_FIRMADO,
    payload: axios
      .post("rar/cargarAdjuntosRAR", data, {
        responseType: "blob",
      })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const postFormularioRgrlFirmado = (file, formulario) => (dispatch) => {
  const data = {
    // este idFormularioCorrespondiente viene a ser el idRGRL que el back
    // resuelve por nosotros, idRGRL **NO** es lo mismo que idFormularioProgramaPreven...
    idRGRL: formulario?.idFormularioCorrespondiente,
    observaciones: "",
    archivosAsociados: [{ base64: file?.value, extension: "pdf" }],
  };

  return dispatch({
    type: POST_FORMULARIO_RGRL_FIRMADO,
    payload: axios
      .post("rgrl/cargarAdjuntosRGRL", data, {
        responseType: "blob",
      })
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const clearVisualizacion = () => (dispatch) => {
  return dispatch({
    type: CLEAR_VISUALIZACION,
  });
};

export const descargarFormularioCancerigenos = (id) => (dispatch) => {
  return dispatch({
    type: DESCARGAR_FORMULARIO_CANCERIGENOS,
    payload: axios
      .get(
        `cancerigenos/descargar81?idFormularioProgramaPrevencionEmpleador=${id}`,
        {
          responseType: "blob",
        }
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getFormularioCancerigenos = (id) => (dispatch) => {
  return dispatch({
    type: GET_FORMULARIO_CANCERIGENOS,
    payload: axios
      .get(
        `cancerigenos/verFormulario81?idFormularioProgramaPrevencionEmpleador=${id}`
      )
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};

export const getEstablecimientosTipoO = () => (dispatch) => {
  return dispatch({
    type: GET_ESTABLECIMIENTOS_TIPO_O,
    payload: axios
      .get(`empleador/dependenciasEmpleador?tipoEstablecimiento=O`)
      .then((response) => ({ data: response.data }))
      .catch((error) => Promise.reject(error)),
  });
};